import type { DealsLink } from "./dealsLink";
import type { TabView } from "./dealsModel";

/**
 * MP-05 on the Deals strip: a page an offer trigger suggests (@highmarch/app offerTriggers.ts — the gear deals after a run of
 * losses, the Master's Collection at a new Mythic chapter, the Welcome Back pack) carries one red dot, and Deals opens
 * on it when the tap that opened it named no page. Viewing the page clears its suggestion for the day. A badge only:
 * nothing here opens by itself.
 */

/** The pages suggested now (none in the quiet after a loss). */
function suggested(l: DealsLink): readonly string[] { return l.catalog.offerTriggers.suggestions(l.now(), l.ctx()).deals; }

/** The strip with a dot on each suggested page. */
export function withSuggestedTabs(tabs: readonly TabView[], l: DealsLink): TabView[] {
  const s = suggested(l);
  return s.length === 0 ? [...tabs] : tabs.map((t) => (s.includes(t.id) ? { ...t, dot: t.dot + 1 } : t));
}

/** The page Deals opens on when none was asked for: the first suggested one on the strip, else null (the first tab). */
export function suggestedPage(l: DealsLink, tabs: readonly TabView[]): string | null {
  const s = suggested(l);
  return tabs.find((t) => s.includes(t.id))?.id ?? null;
}

/** The Deals screen drew `pageId`: its suggestion is seen (the pill's and the tab's dot clear). */
export function suggestedPageShown(l: DealsLink, pageId: string | null): void {
  if (pageId !== null && l.catalog.offerTriggers.viewed(pageId, l.now(), l.ctx())) l.changed();
}
